export class FetchError extends Error {
  public status?: number
  public info?: any
  public correlationId?: any
}
